<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Support</div>
    </template>

    <div class="grey lighten-3" style="height: 100%">
      <v-list class="py-0 rounded-lg">
        <menu-item>
          <span class="mr-4">Email:</span><a href="mailto:support@referra.pro">support@referra.pro</a>
        </menu-item>

        <v-divider/>

        <menu-item :to="{ name: 'support/start' }" title="Getting Started" />

        <v-divider/>
        
        <menu-item :to="{ name: 'support/logs' }" title="Logs" />
      </v-list>
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage, MenuItem } from '@/components/pages'
import { mapActions } from 'vuex'

export default {
  name: "YouSupportMenuView",

  components: { ContentPage, MenuItem },

  methods: {
    ...mapActions('auth', ['loadMe']),
  },

  created() {
    this.loadMe()
  }
}
</script>